(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[933],{

/***/ 52225:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* reexport */ JobClientDetails_JobClientDetails; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./utils/limitTextLength.ts
var limitTextLength = __webpack_require__(69764);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/useMediaQuery/useMediaQuery.js
var useMediaQuery = __webpack_require__(63457);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/Typography/Typography.js
var Typography = __webpack_require__(22318);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/styles/useTheme.js
var useTheme = __webpack_require__(8920);
// EXTERNAL MODULE: ./components/JobClientDetails/JobClientDetails.module.scss
var JobClientDetails_module = __webpack_require__(41936);
var JobClientDetails_module_default = /*#__PURE__*/__webpack_require__.n(JobClientDetails_module);
;// CONCATENATED MODULE: ./components/JobClientDetails/JobClientDetails.tsx





var JobClientDetails = function(param) {
    var data = param.data, user = param.user, _showDetails = param.showDetails, showDetails = _showDetails === void 0 ? true : _showDetails;
    var theme = (0,useTheme/* default */.Z)();
    var isAllowedToDisplay = data.displayClientName !== false;
    var isMobile = (0,useMediaQuery/* default */.Z)(theme.breakpoints.down("xs"));
    if (isMobile || !showDetails) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {});
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            user && isAllowedToDisplay && /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                variant: "subtitle1",
                component: "h6",
                className: (JobClientDetails_module_default()).clientName,
                children: data.accountName
            }),
            user && !isAllowedToDisplay && /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                variant: "subtitle1",
                component: "h6",
                className: (JobClientDetails_module_default()).clientName,
                children: data.clientNameMessage || "Client Name Withheld"
            }),
            data.clientDescriptionPlainText && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                children: (0,limitTextLength/* textlengthLimit */.r)(data === null || data === void 0 ? void 0 : data.clientDescriptionPlainText, 300)
            })
        ]
    });
};
/* harmony default export */ var JobClientDetails_JobClientDetails = (JobClientDetails);

;// CONCATENATED MODULE: ./components/JobClientDetails/index.tsx



/***/ }),

/***/ 73037:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "ym": function() { return /* binding */ JobInformation; }
});

// UNUSED EXPORTS: JobInfoStyle, salaryFormat

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__(93967);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ./node_modules/dayjs/dayjs.min.js
var dayjs_min = __webpack_require__(27484);
var dayjs_min_default = /*#__PURE__*/__webpack_require__.n(dayjs_min);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/List/List.js
var List = __webpack_require__(62822);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/ListItem/ListItem.js
var ListItem = __webpack_require__(50998);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/ListItemIcon/ListItemIcon.js
var ListItemIcon = __webpack_require__(46869);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/ListItemText/ListItemText.js
var ListItemText = __webpack_require__(95757);
// EXTERNAL MODULE: ./components/JobInformation/JobInformation.module.scss
var JobInformation_module = __webpack_require__(91805);
var JobInformation_module_default = /*#__PURE__*/__webpack_require__.n(JobInformation_module);
;// CONCATENATED MODULE: ./components/JobInformation/icons/building.svg
var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }

var SvgBuilding = function SvgBuilding(props) {
  return /*#__PURE__*/react.createElement("svg", _extends({
    viewBox: "0 0 14 15",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/react.createElement("path", {
    d: "M4.376 7.422c0 .191.136.328.328.328h1.094a.332.332 0 0 0 .328-.328V6.328A.353.353 0 0 0 5.798 6H4.704a.332.332 0 0 0-.328.328v1.094Zm3.828.328h1.094a.332.332 0 0 0 .328-.328V6.328A.353.353 0 0 0 9.298 6H8.204a.332.332 0 0 0-.328.328v1.094c0 .191.136.328.328.328Zm-2.078 2.297V8.953a.353.353 0 0 0-.328-.328H4.704a.332.332 0 0 0-.328.328v1.094c0 .191.136.328.328.328h1.094a.332.332 0 0 0 .328-.328Zm2.078.328h1.094a.332.332 0 0 0 .328-.328V8.953a.353.353 0 0 0-.328-.328H8.204a.332.332 0 0 0-.328.328v1.094c0 .191.136.328.328.328Zm4.922 3.39a.353.353 0 0 0-.329-.328h-.546V3.102c0-.329-.301-.602-.657-.602H9.188V1.406c0-.355-.3-.656-.656-.656H5.469c-.382 0-.656.3-.656.656V2.5H2.38c-.356 0-.657.273-.657.602v10.336h-.52a.333.333 0 0 0-.327.328v.984h12.25v-.984Zm-10.09-.355V3.812h1.777v.657c0 .383.274.656.656.656h3.063a.648.648 0 0 0 .656-.656v-.657h1.75v9.598H7.876v-1.832a.353.353 0 0 0-.328-.328H6.454a.333.333 0 0 0-.328.328v1.832h-3.09ZM8.149 2.5c.082 0 .164.082.164.164v.547c0 .11-.082.164-.164.164h-.71v.71c0 .11-.083.165-.165.165h-.547c-.11 0-.164-.055-.164-.164v-.711h-.71c-.11 0-.165-.055-.165-.164v-.547c0-.082.055-.164.164-.164h.711v-.71c0-.083.055-.165.164-.165h.547c.082 0 .164.082.164.164V2.5h.711Z"
  })));
};
/* harmony default export */ var building = (SvgBuilding);
;// CONCATENATED MODULE: ./components/JobInformation/icons/calendar.svg
var calendar_path;
function calendar_extends() { return calendar_extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, calendar_extends.apply(null, arguments); }

var SvgCalendar = function SvgCalendar(props) {
  return /*#__PURE__*/react.createElement("svg", calendar_extends({
    viewBox: "0 0 14 15",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), calendar_path || (calendar_path = /*#__PURE__*/react.createElement("path", {
    d: "M11.813 2.5h-1.312V1.078a.353.353 0 0 0-.329-.328H9.08a.332.332 0 0 0-.328.328V2.5h-3.5V1.078A.353.353 0 0 0 4.923.75H3.829a.332.332 0 0 0-.328.328V2.5H2.188C1.45 2.5.876 3.102.876 3.813v9.624c0 .739.574 1.313 1.312 1.313h9.625c.711 0 1.313-.574 1.313-1.313V3.813A1.33 1.33 0 0 0 11.813 2.5Zm-.164 10.938H2.352c-.11 0-.164-.055-.164-.165V5.125h9.625v8.148c0 .11-.082.165-.164.165Z"
  })));
};
/* harmony default export */ var calendar = (SvgCalendar);
;// CONCATENATED MODULE: ./components/JobInformation/icons/local.svg
var local_path;
function local_extends() { return local_extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, local_extends.apply(null, arguments); }

var SvgLocal = function SvgLocal(props) {
  return /*#__PURE__*/react.createElement("svg", local_extends({
    viewBox: "0 0 12 15",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), local_path || (local_path = /*#__PURE__*/react.createElement("path", {
    d: "M6 .75A5.251 5.251 0 0 0 .75 6c0 1.969.63 2.57 4.13 8.148.52.82 1.695.82 2.214 0 3.5-5.578 4.157-6.18 4.157-8.148C11.25 3.102 8.87.75 6 .75Zm0 12.688C2.5 7.859 2.064 7.503 2.064 6c0-2.16 1.75-3.938 3.938-3.938C8.16 2.063 9.938 3.84 9.938 6c0 1.504-.437 1.805-3.937 7.438ZM3.814 6a2.16 2.16 0 0 0 2.188 2.188A2.176 2.176 0 0 0 8.188 6a2.194 2.194 0 0 0-2.187-2.188c-1.23 0-2.188.985-2.188 2.188Z"
  })));
};
/* harmony default export */ var local = (SvgLocal);
;// CONCATENATED MODULE: ./components/JobInformation/icons/money.svg
var money_path;
function money_extends() { return money_extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, money_extends.apply(null, arguments); }

var SvgMoney = function SvgMoney(props) {
  return /*#__PURE__*/react.createElement("svg", money_extends({
    viewBox: "0 0 18 11",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), money_path || (money_path = /*#__PURE__*/react.createElement("path", {
    d: "M9 2.688c-1.476 0-2.624 1.394-2.624 3.062 0 1.695 1.148 3.063 2.625 3.063 1.449 0 2.625-1.368 2.625-3.063 0-1.668-1.176-3.063-2.625-3.063Zm1.094 4.593c0 .137-.109.219-.218.219h-1.75c-.137 0-.22-.082-.22-.219v-.437c0-.11.083-.219.22-.219h.437V5.121h-.027a.207.207 0 0 1-.11.055.23.23 0 0 1-.191-.11l-.246-.355c-.027-.027-.027-.082-.027-.137 0-.054.027-.136.082-.164l.437-.273A.576.576 0 0 1 8.837 4h.382c.11 0 .22.11.22.219v2.406h.437c.109 0 .218.11.218.219v.437ZM16.876.5H1.126a.881.881 0 0 0-.875.875v8.75c0 .492.382.875.875.875h15.75a.881.881 0 0 0 .875-.875v-8.75A.9.9 0 0 0 16.876.5Zm-.438 7.438c-.984 0-1.75.792-1.75 1.75H3.313c0-.958-.793-1.75-1.75-1.75V3.563c.957 0 1.75-.766 1.75-1.75h11.375c0 .984.766 1.75 1.75 1.75v4.374Z"
  })));
};
/* harmony default export */ var money = (SvgMoney);
;// CONCATENATED MODULE: ./components/JobInformation/index.tsx













var JobInfoStyle;
(function(JobInfoStyle) {
    JobInfoStyle["Vertical"] = "Vertical";
    JobInfoStyle["Horizontal"] = "Horizontal";
})(JobInfoStyle || (JobInfoStyle = {}));
var dateFormat = function(date) {
    return date ? dayjs_min_default()(date).format("DD MMM YYYY") : /* istanbul ignore next */ null;
};
var getJobDates = function(workType, startDate, endDate) {
    return workType === "Permanent" ? showPermanentDate(startDate) : showLocumDate(startDate, endDate);
};
var showPermanentDate = function(startDate) {
    if (!startDate || new Date(startDate).valueOf() < new Date().valueOf()) {
        return "Start dates are flexible";
    }
    return "Available from ".concat(dateFormat(startDate));
};
var showLocumDate = function(startDate, endDate) {
    var endD = endDate ? " ~ ".concat(dateFormat(endDate)) : "";
    if (!startDate || new Date(startDate).valueOf() < new Date().valueOf()) {
        return "NOW".concat(endD);
    }
    return "".concat(dateFormat(startDate)).concat(endD);
};
var salaryFormat = function(num) {
    /* istanbul ignore if */ if (!num) {
        return null;
    }
    var str = num.toString();
    var reg = str.indexOf(".") > -1 ? /(\d)(?=(\d{3})+\.)/g : /(\d)(?=(?:\d{3})+$)/g;
    return str.replace(reg, "$1,");
};
var isValidValue = function(payValue) {
    return payValue && payValue > 0;
};
var showPay = function(workType, payRate, payInterval, salaryFrom, salaryTo, ofBillings, guaranteedHourlyRate) {
    if (ofBillings && isValidValue(ofBillings) && guaranteedHourlyRate && isValidValue(guaranteedHourlyRate)) {
        return "".concat(ofBillings, "% of billings or $").concat(guaranteedHourlyRate, " Guaranteed Hourly Rate");
    }
    if (ofBillings && isValidValue(ofBillings)) {
        return "".concat(ofBillings, "% of billings");
    }
    if (guaranteedHourlyRate && isValidValue(guaranteedHourlyRate)) {
        return "$".concat(guaranteedHourlyRate, " Guaranteed Hourly Rate");
    }
    if (workType === "Locum" && payRate && isValidValue(payRate)) {
        var ref;
        return "$".concat((ref = salaryFormat(payRate)) !== null && ref !== void 0 ? ref : "", " ").concat(payInterval !== null && payInterval !== void 0 ? payInterval : "");
    }
    if (workType === "Permanent" && salaryFrom && isValidValue(salaryFrom) && salaryTo && isValidValue(salaryTo)) {
        var ref1, ref2;
        return "$".concat((ref1 = salaryFormat(salaryFrom)) !== null && ref1 !== void 0 ? ref1 : "", " ~ $").concat((ref2 = salaryFormat(salaryTo)) !== null && ref2 !== void 0 ? ref2 : "");
    }
    return "Available on application";
};
var showLocation = function(location) {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            location.city && /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                "data-testid": "job-location-city",
                children: [
                    location.city,
                    ", "
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                "data-testid": "job-location-state",
                children: location.state
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                "data-testid": "job-location-country",
                children: [
                    " ",
                    location.country
                ]
            })
        ]
    });
};
var JobInformation = function(param) {
    var job = param.job, style = param.style;
    var workType = job.workType, city = job.city, country = job.country, locationDisplay = job.locationDisplay, payRate = job.payRate, payInterval = job.payInterval, endDate = job.endDate, startDate = job.startDate, salaryFrom = job.salaryFrom, salaryTo = job.salaryTo, ofBillings = job.ofBillings, guaranteedHourlyRate = job.guaranteedHourlyRate;
    var information = [
        {
            icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(local, {
                width: 15
            }),
            content: showLocation({
                city: city,
                state: locationDisplay,
                country: country
            }),
            tag: "location",
            label: "Location"
        },
        {
            icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(building, {
                width: 15
            }),
            content: workType,
            tag: "workType",
            label: "Work Type"
        },
        {
            icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(money, {
                width: 18
            }),
            content: showPay(workType, payRate, payInterval, salaryFrom, salaryTo, ofBillings, guaranteedHourlyRate),
            tag: "salary",
            label: "Salary"
        },
        {
            icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(calendar, {
                width: 18
            }),
            content: getJobDates(workType, startDate, endDate),
            tag: "date",
            label: "Date"
        }, 
    ];
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(List/* default */.Z, {
        className: classnames_default()((JobInformation_module_default()).container, style && (JobInformation_module_default())[style]),
        "data-testid": "job-info",
        children: information.map(function(item) {
            return /*#__PURE__*/ (0,jsx_runtime.jsxs)(ListItem/* default */.Z, {
                className: classnames_default()((JobInformation_module_default()).listItem, (JobInformation_module_default())[item.tag]),
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ListItemIcon/* default */.Z, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                            className: (JobInformation_module_default()).icon,
                            "aria-hidden": "true",
                            children: item.icon
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ListItemText/* default */.Z, {
                        "aria-label": item.label,
                        "data-testid": item.label,
                        children: item.content
                    })
                ]
            }, item.tag);
        })
    });
};


/***/ }),

/***/ 35079:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* reexport */ ShareContainer_ShareContainer; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./utils/urlHelper.ts
var urlHelper = __webpack_require__(52484);
// EXTERNAL MODULE: ./utils/useAnalytics.ts + 2 modules
var useAnalytics = __webpack_require__(9800);
// EXTERNAL MODULE: ./utils/useCloseOnOutsideClick.ts
var useCloseOnOutsideClick = __webpack_require__(42361);
// EXTERNAL MODULE: ./node_modules/next/dynamic.js
var dynamic = __webpack_require__(5152);
var dynamic_default = /*#__PURE__*/__webpack_require__.n(dynamic);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/Button/Button.js
var Button = __webpack_require__(282);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/Fade/Fade.js
var Fade = __webpack_require__(73637);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/Popper/Popper.js + 1 modules
var Popper = __webpack_require__(84872);
// EXTERNAL MODULE: ./node_modules/@material-ui/icons/ShareOutlined.js
var ShareOutlined = __webpack_require__(92217);
// EXTERNAL MODULE: ./components/ShareContainer/ShareContainer.module.scss
var ShareContainer_module = __webpack_require__(4423);
var ShareContainer_module_default = /*#__PURE__*/__webpack_require__.n(ShareContainer_module);
;// CONCATENATED MODULE: ./components/ShareContainer/ShareContainer.tsx













var ShareEmail = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 9272).then(__webpack_require__.bind(__webpack_require__, 19272));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(19272)
            ];
        }
    }
});
var ShareFacebook = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 7753).then(__webpack_require__.bind(__webpack_require__, 37753));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(37753)
            ];
        }
    }
});
var ShareLink = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 9261).then(__webpack_require__.bind(__webpack_require__, 29261));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(29261)
            ];
        }
    }
});
var ShareContainer = function(param) {
    var className = param.className, buttonClassName = param.buttonClassName, _text = param.text, text = _text === void 0 ? "Share" : _text, emailTitle = param.emailTitle, emailSubject = param.emailSubject, emailBody = param.emailBody, facebookTitle = param.facebookTitle, shareUrl = param.shareUrl, shareTrackingProps = param.shareTrackingProps, id = param.id, _popperPlacement = param.popperPlacement, popperPlacement = _popperPlacement === void 0 ? "bottom" : _popperPlacement, jobOrArticleShare = param.jobOrArticleShare;
    var ref;
    var url = shareUrl !== null && shareUrl !== void 0 ? shareUrl : (ref = globalThis.location) === null || ref === void 0 ? void 0 : ref.href;
    var ref1 = (0,react.useState)(false), isShareOpen = ref1[0], setIsShareOpen = ref1[1];
    var ref2 = (0,react.useState)(false), isDialogOpen = ref2[0], setIsDialogOpen = ref2[1];
    var shareButtonRef = (0,react.useRef)(null);
    var containerRef = (0,useCloseOnOutsideClick/* useCloseOnOutsideClick */.N)(isShareOpen && !isDialogOpen, setIsShareOpen);
    var popperId = "share-dropdown_".concat(id);
    var track = (0,useAnalytics/* useAnalytics */.z)();
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        ref: containerRef,
        className: className,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                variant: "outlined",
                color: "secondary",
                "data-testid": "share-dropdown-button",
                ref: shareButtonRef,
                onClick: function() {
                    setIsShareOpen(!isShareOpen);
                    track("Click Share button", shareTrackingProps.details);
                },
                "aria-controls": popperId,
                "aria-haspopup": "true",
                "aria-expanded": isShareOpen,
                startIcon: /*#__PURE__*/ (0,jsx_runtime.jsx)(ShareOutlined/* default */.Z, {}),
                fullWidth: true,
                className: buttonClassName,
                children: text
            }),
            isShareOpen ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Popper/* default */.Z, {
                id: popperId,
                "data-testid": "share-dropdown",
                open: isShareOpen,
                anchorEl: shareButtonRef.current,
                placement: popperPlacement,
                transition: true,
                disablePortal: true,
                className: (ShareContainer_module_default()).popper,
                children: function(param) {
                    var TransitionProps = param.TransitionProps;
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Fade/* default */.Z, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, TransitionProps), {
                        timeout: 350,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: (ShareContainer_module_default()).dropdownContainer,
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: (ShareContainer_module_default()).item,
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ShareLink, {
                                        shareUrl: (0,urlHelper/* getUtmShareUrl */.En)(jobOrArticleShare, url, "copy"),
                                        onClick: function() {
                                            setIsShareOpen(false);
                                            track(shareTrackingProps.name, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, shareTrackingProps.details), {
                                                "Share Type": "Link"
                                            }));
                                        },
                                        className: (ShareContainer_module_default()).button
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: (ShareContainer_module_default()).item,
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ShareEmail, {
                                        title: emailTitle,
                                        subject: emailSubject,
                                        body: emailBody,
                                        onClick: function() {
                                            setIsShareOpen(false);
                                            track(shareTrackingProps.name, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, shareTrackingProps.details), {
                                                "Share Type": "Email"
                                            }));
                                        },
                                        className: (ShareContainer_module_default()).button,
                                        onDialogStatusChange: function(isDialogOpen) {
                                            return setIsDialogOpen(isDialogOpen);
                                        }
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: (ShareContainer_module_default()).item,
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ShareFacebook, {
                                        title: facebookTitle,
                                        shareUrl: (0,urlHelper/* getUtmShareUrl */.En)(jobOrArticleShare, url, "social"),
                                        onClick: function() {
                                            setIsShareOpen(false);
                                            track(shareTrackingProps.name, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, shareTrackingProps.details), {
                                                "Share Type": "Facebook"
                                            }));
                                        },
                                        className: (ShareContainer_module_default()).button
                                    })
                                })
                            ]
                        })
                    }));
                }
            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {})
        ]
    });
};
/* harmony default export */ var ShareContainer_ShareContainer = (ShareContainer);

;// CONCATENATED MODULE: ./components/ShareContainer/index.tsx



/***/ }),

/***/ 69764:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "r": function() { return /* binding */ textlengthLimit; }
/* harmony export */ });
var textlengthLimit = function(text, lengthLimit) {
    var splitWords = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : false;
    if (!text || text.length <= lengthLimit) {
        return text;
    }
    if (!splitWords) {
        text = text.substring(0, text.lastIndexOf(" "));
    }
    text = text.substring(0, lengthLimit - 3);
    return "".concat(text, "...");
};


/***/ }),

/***/ 42361:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "N": function() { return /* binding */ useCloseOnOutsideClick; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);

function useCloseOnOutsideClick(isOpen, onToggle) {
    var containerRef = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)(null);
    // close if clicked outside
    var handleOutsideClick = (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)(function(e) {
        if (isOpen) {
            var ref;
            if ((ref = containerRef.current) === null || ref === void 0 ? void 0 : ref.contains(e.target)) {
                // inside click
                return;
            }
            // outside click
            onToggle(false);
        }
    }, [
        isOpen
    ]);
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function() {
        document.addEventListener("mousedown", handleOutsideClick);
        return function() {
            return document.removeEventListener("mousedown", handleOutsideClick);
        };
    }, [
        handleOutsideClick
    ]);
    return containerRef;
}


/***/ }),

/***/ 41936:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"clientName":"JobClientDetails_clientName__eCc__"};

/***/ }),

/***/ 91805:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"container":"JobInformation_container__kcZzF","listItem":"JobInformation_listItem__2_NiH","Horizontal":"JobInformation_Horizontal__8VA_F","location":"JobInformation_location__wYjH_","workType":"JobInformation_workType__evbI0","salary":"JobInformation_salary__5Mwvj","date":"JobInformation_date__qUjZq","icon":"JobInformation_icon__JB_Sd"};

/***/ }),

/***/ 4423:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"popper":"ShareContainer_popper__X1uVQ","dropdownContainer":"ShareContainer_dropdownContainer__rv05R","item":"ShareContainer_item__XEkFy","button":"ShareContainer_button__kMMgg"};

/***/ })

}]);